'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main', {
    url: '/?_pageNum&_pageSize&_sortyBy&facilityName&jobClass&areaName&assignmentStartDate',
    template: '<main></main>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/main/main.routes.js